import classnames from 'classnames'

const save = props => {

	const {
		attributes,
	} = props

	const {
		className
	} = attributes

	if( ! ( attributes.placeholder > 0 ) ) {
		delete attributes.placeholder
	}

	const data = {
		'data-attributes': JSON.stringify( attributes ),
	}

	return (
		<div className={ classnames( [
			'wp-block-czgb-products',
			className,
		], {} ) } { ...data }>
		</div>
	)
}

export default save